<template>
  <div class="md-layout md-gutter moreInfoGroup">
    <!--div class="md-layout-item md-size-5 tog-label">
      <label>{{ $t("localization.natural") }}</label>
    </div-->
    <div class="md-layout-item md-size-35 plot-type-btn">
      <toggle-buttons :btnList="naturalList" @btnValue="getNatural" :editTB="$store.state.plot.localization.forest_origin_natural" />
    </div>
    <div class="md-layout-item md-size-20" v-if="$store.state.plot.localization.forest_origin_natural === '02'">
      <md-field :md-counter="false" :class="!checkYear($store.state.plot.localization.forest_origin_year) ? 'md-invalid' : ''">
        <label for="year">{{ $t("localization.year") }}</label>
        <md-input type="number" name="year" v-model="$store.state.plot.localization.forest_origin_year" maxlength="4" />
        <span class="md-error">{{ $t("error.errorRange") }} (1900-2100)</span>
      </md-field>
    </div>
    <div class="md-layout-item md-size-45">
      <md-field>
        <select v-model="$store.state.plot.localization.forest_origin_detail" name="detail">
          <option disabled value="">{{ $t("localization.detail") }}</option>
          <option v-for="(det, key) in detailList" :value="key" :key="key">{{ det }}</option>
        </select>
      </md-field>
    </div>
  </div>
</template>

<script>
import ToggleButtons from '@/components/ToggleButtons'

import { getDomain } from '@/assets/scripts/domainsManager'
import { checkYear } from '@/assets/scripts/formatData'

const NATURAL = 'forest_origin'
const DETAIL = 'forest_origin_detail'

export default {
  name: 'Origin',
  components: {
    ToggleButtons
  },
  data: () => ({
    checkYear: checkYear,
    naturalList: {},
    detailList: {}
  }),
  mounted () {
    getDomain(NATURAL).then(data => {
      this.naturalList = data[this.$i18n.locale]
    })
    getDomain(DETAIL).then(data => {
      this.detailList = data[this.$i18n.locale]
    })
  },
  methods: {
    getNatural: function (natural) {
      this.$store.state.plot.localization.forest_origin_natural = natural
      if (natural !== '02') {
        this.$store.state.plot.localization.forest_origin_year = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .tog-label {
    margin-top: 23px;
  }

  .plot-type-btn {
    margin-top: -10px;
    /* padding-left: 30px !important; */
  }
</style>
